// extracted by mini-css-extract-plugin
export default {"content":"History_content__XiPcD","h2":"History_h2__EtNGw","text":"History_text__kq7dN","link":"History_link__u4Bb0"};